<template lang="html">
  <v-container fluid>
    <v-toolbar dense dark tile flat class="title text-center text-md-left">
      {{ event.type == 'overnight' ? 'Group Information' : 'Event Information'}}
    </v-toolbar>
    <v-row>
      <v-col sm="12">
        <v-text-field
          v-model="event.title"
          :label="event.type == 'overnight' ? 'Group Name*' : 'Event Title*'"
          outlined
          color="secondary"
          :rules="rules.required"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col sm="12">
        <v-textarea
          v-model="event.description"
          :label="event.type == 'overnight' ? 'Group Mailing Address' : 'Description'"
          outlined
          color="secondary"
        >
        </v-textarea>
      </v-col>
      <v-col cols="12" v-if="event.type == 'ministry-offSite'">
        <v-textarea
          v-model="event.location"
          label="Where will this event be held (location name and address)"
          outlined
          color="secondary"
        >
        </v-textarea>
      </v-col>
      <v-col sm="12" v-if="event.type == 'external'">
        <v-text-field
          v-model="event.groupName"
          label="Group Name:"
          outlined
          color="secondary"
        >
        </v-text-field>
      </v-col>
      <v-col sm="12" v-if="event.type == 'external'">
        <v-text-field
          v-model="event.groupAddress"
          label="Group Mailing Address:"
          outlined
          color="secondary"
        >
        </v-text-field>
      </v-col>
      <v-col md="6" cols="12">
        <v-menu
          ref="startMenu"
          v-model="startMenu"
          :close-on-content-click="false"
          :return-value.sync="event.startDate"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="event.startDate"
              :label="event.type == 'overnight' ? 'Arrival Date*' : event.type == 'promotion' ? 'When to Begin Promotion' : 'Begin Date*'"
              color="secondary"
              clearable
              outlined
              readonly
              :rules="rules.required"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="event.startDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="secondary" @click="startMenu = false">Cancel</v-btn>
            <v-btn text color="secondary" @click="$refs.startMenu.save(event.startDate)">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <!-- IF THE EVENT IS AN OVERNIGHT REQUEST GET START AND END DATE -->
      <v-col md="6" cols="12">
        <v-menu
          ref="endMenu"
          v-model="endMenu"
          :close-on-content-click="false"
          :return-value.sync="event.endDate"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="event.endDate"
              :label="event.type == 'overnight' ? 'Departure Date*' : event.type == 'promotion' ? 'When to End Promotion' : 'End Date (if over multiple days)'"
              color="secondary"
              clearable
              outlined
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="event.endDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="secondary" @click="endMenu = false">Cancel</v-btn>
            <v-btn text color="secondary" @click="$refs.endMenu.save(event.endDate)">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col md="3" cols="12" v-if="event.type != 'overnight' && event.type != 'promotion'">
        <v-text-field
          v-model="event.startTime"
          label="Start Time*"
          outlined
          color="secondary"
          :rules="rules.required"
        >
        </v-text-field>
      </v-col>
      <v-col md="3" cols="12" v-if="event.type != 'overnight' && event.type != 'promotion'">
        <v-text-field
          v-model="event.endTime"
          label="End Time"
          outlined
          color="secondary"
        >
        </v-text-field>
      </v-col>
      <v-col sm="12" md="6" v-if="event.type != 'overnight' && event.type != 'ministry-offSite' && event.type != 'promotion'">
        <v-text-field
          v-model="event.setupDate"
          label="When Would You Like to Set Up?"
          outlined
          color="secondary"
        >
        </v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import mixins from '@/plugins/mixins'
export default {
  mixins: [mixins],
  props: {
    eventInfo : Object
  },
  data(){
    return {
      endMenu   : false,
      event     : this.eventInfo,
      startMenu : false,
    }
  }
}
</script>

<style lang="css" scoped>
</style>
